





































































































































































































import { Component, Vue, Prop, PropSync, Watch } from "vue-property-decorator";

interface CalendarEvent {
  id?: string;
  title: string;
  start: Date | string;
  end?: Date | string;
  description?: string;
  color?: string;
  category?: string;
  allDay?: boolean;
}

@Component({
  name: "EventDialog",
})
export default class EventDialog extends Vue {
  @PropSync("value", { type: Boolean }) dialog!: boolean;
  @Prop({ default: null }) event!: CalendarEvent | null;

  valid = false;
  localEvent: CalendarEvent = {
    title: "",
    start: new Date(),
    allDay: false,
    color: "#519DE1",
  };

  startDate = "";
  startTime = "09:00";
  endDate = "";
  endTime = "10:00";

  startDateMenu = false;
  startTimeMenu = false;
  endDateMenu = false;
  endTimeMenu = false;

  categories = [
    "Trabajo",
    "Personal",
    "Reunión",
    "Evento",
    "Recordatorio",
    "Otro",
  ];

  rules = {
    required: (value: any) => !!value || "Campo requerido",
  };

  get isEditing(): boolean {
    return !!(this.event && this.event.id);
  }

  get startDateFormatted(): string {
    return this.formatDate(this.startDate);
  }

  get endDateFormatted(): string {
    return this.formatDate(this.endDate);
  }

  @Watch("dialog")
  onDialogChange(val: boolean) {
    if (val && this.event) {
      this.loadEvent();
    }
  }

  loadEvent() {
    if (!this.event) return;

    this.localEvent = { ...this.event };

    const startDate = new Date(this.event.start);
    this.startDate = this.toISODate(startDate);
    this.startTime = this.toTime(startDate);

    if (this.event.end) {
      const endDate = new Date(this.event.end);
      this.endDate = this.toISODate(endDate);
      this.endTime = this.toTime(endDate);
    } else {
      this.endDate = this.startDate;
      this.endTime = this.addHours(this.startTime, 1);
    }
  }

  save() {
    if (!(this.$refs.form as any).validate()) return;

    const startDateTime = this.combineDateTime(
      this.startDate,
      this.localEvent.allDay ? "00:00" : this.startTime
    );
    const endDateTime = this.combineDateTime(
      this.endDate || this.startDate,
      this.localEvent.allDay ? "23:59" : this.endTime
    );

    const savedEvent: CalendarEvent = {
      ...this.localEvent,
      start: startDateTime,
      end: endDateTime,
    };

    this.$emit("save", savedEvent);
    this.close();
  }

  deleteEvent() {
    this.$emit("delete", this.localEvent);
    this.close();
  }

  close() {
    this.dialog = false;
    this.resetForm();
  }

  resetForm() {
    const formRef = this.$refs.form as any;
    if (formRef) {
      formRef.reset();
    }
    this.localEvent = {
      title: "",
      start: new Date(),
      allDay: false,
      color: "#519DE1",
    };
  }

  // Helper methods
  toISODate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  toTime(date: Date): string {
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${hours}:${minutes}`;
  }

  formatDate(date: string): string {
    if (!date) return "";
    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year}`;
  }

  combineDateTime(date: string, time: string): Date {
    return new Date(`${date}T${time}:00`);
  }

  addHours(time: string, hours: number): string {
    const [h, m] = time.split(":").map(Number);
    const newHours = (h + hours) % 24;
    return `${String(newHours).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
  }
}
